import { render, staticRenderFns } from "./notice-update.vue?vue&type=template&id=606abfb1&scoped=true&"
import script from "./notice-update.vue?vue&type=script&lang=js&"
export * from "./notice-update.vue?vue&type=script&lang=js&"
import style0 from "./notice-update.vue?vue&type=style&index=0&id=606abfb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606abfb1",
  null
  
)

export default component.exports